/**
 * Componente de tabla de productos de inventario
 * Inventory products table component
 */

import { AgGridTable, AgGridTableRef } from '@shared/components/ui/AgGridTable';
import { useEffect, useRef, useState } from 'react';
import { useAgGridColumns } from '../../hooks/useAgGridColumns';
import { InventoryProduct } from '../../models/InventoryApiResponse';

interface ProductStatisticsTableProps {
  data: InventoryProduct[];
  isFetching?: boolean;
  selectedColumns: string[];
}

export const ProductStatisticsTable = ({
  data,
  isFetching = false,
  selectedColumns,
}: ProductStatisticsTableProps) => {
  const agGridRef = useRef<AgGridTableRef>(null);
  const [persistedData, setPersistedData] = useState<InventoryProduct[]>(data);
  const shouldDimTable = isFetching;

  // Mantener los datos previos mientras se está realizando una nueva búsqueda
  // Keep previous data while a new fetch/search is in progress
  useEffect(() => {
    if (!isFetching) {
      setPersistedData(data);
    }
  }, [data, isFetching]);

  // Obtener definiciones de columnas
  // Get column definitions
  const { filteredColumnDefs } = useAgGridColumns({
    selectedColumns,
  });

  // Handler para cuando la grid está lista
  // Handler for when grid is ready
  const handleGridReady = () => {
    // No-op: la grid se configura automáticamente
  };

  return (
    <div
      className={`w-full transition-opacity duration-300 ${
        shouldDimTable ? 'opacity-50 pointer-events-none' : 'opacity-100'
      }`}
    >
      <AgGridTable
        ref={agGridRef}
        data={shouldDimTable ? persistedData : data}
        columnDefs={filteredColumnDefs}
        height="calc(100vh - 150px)"
        enableSelection={false}
        onGridReady={handleGridReady}
        className="rounded-lg shadow-sm"
        rowHeight={60}
      />
    </div>
  );
};
